import React, { useEffect, useState } from "react";
import Layout from "components/LayoutForPortal";
import Title from "components/Title";
import { Button, Input, Tag } from "antd";
import { useDispatch, useSelector } from "react-redux";
import SelectFilter from "components/Filters/CallFilters";
import IntlMessages from "util/IntlMessages";
import ActionDropdown from "components/Table/ActionDropdown";
import InventoryTable from "components/Table/BasicTable";
import AddItemModal from "./components/AddItemModal";
import { DataGetActionAPI } from "../../../redux/actions/http";
import DeleteConfirmNew from "components/Modal/DeleteConfirmNew";
import EditItemModal from "./components/EditItemModal";
import AssignWatchModal from "./components/AssignWatchModal";
const Inventory = () => {
  const dispatch = useDispatch();
  const inventoryProps = useSelector((state) => state.inventory);
  const { allInventory, inventorySpinner, initialValues } = inventoryProps;

  console.log("allInventory", allInventory, initialValues);

  const toggleAddItemModal = () => {
    dispatch({ type: "Show_AddItem_Modal" });
  };

  const toggleEditItemModal = (record) => {
    dispatch({ type: "Show_EditItem_Modal", payload: record });
  };

  const toggleAssignWatchModal = (record) => {
    dispatch({ type: "Show_AssignWatch_Modal", payload: record });
  };

  useEffect(() => {
    dispatch(
      DataGetActionAPI(
        "getAllHealthBands",
        "getInventory",
        { query: "all" },
        "InventoryLoading"
      )
    );
  }, []);

  const renderStatus = (status) => {
    switch (status) {
      case "unassigned":
        return <Tag color="orange">Unassigned</Tag>;
      case "assigned":
        return <Tag color="green">Assigned</Tag>;
      case "outOfOrder":
        return <Tag color="black">Out of Order</Tag>;
      case "deleted":
        return <Tag color="red">Deleted</Tag>;
    }
  };

  const columns = [
    {
      title: <IntlMessages id="inventory.imei" />,
      render: (record) => <span>{record.imei}</span>,
      key: "imei",
    },
    {
      title: <IntlMessages id="inventory.name" />,
      render: (record) => <span>{record.name}</span>,
      key: "name",
    },
    {
      title: <IntlMessages id="inventory.model" />,
      render: (record) => <span>{record.model}</span>,
      key: "model",
    },
    {
      title: <IntlMessages id="inventory.corporateAccount" />,
      render: (record) => (
        <span>
          {record?.corporateAccountId
            ? record?.corporateAccountId?.fullName
            : "N/A"}
        </span>
      ),
      key: "corporateAccount",
    },
    {
      title: <IntlMessages id="inventory.assignedTo" />,
      render: (record) => (
        <span>{record.assignedTo ? record.assignedTo.fullName : "N/A"}</span>
      ),
      key: "assignedTo",
    },
    {
      title: "Notes",
      render: (record) => <span>{record.notes || "__"}</span>,
      key: "notes",
    },
    {
      title: <IntlMessages id="inventory.status" />,
      render: (record) => renderStatus(record.status),
      key: "status",
    },
    {
      title: "",
      render: (record) => {
        return (
          record.status !== "deleted" && (
            <ActionDropdown menu={renderActions(record)}></ActionDropdown>
          )
        );
      },
      key: "action",
    },
  ];

  const renderActions = (record) => {
    return (
      <div className="gx-d-flex gx-flex-column">
        {record.status !== "outOfOrder" && (
          <span
            style={{ cursor: "pointer" }}
            onClick={() => toggleEditItemModal(record)}
          >
            {" "}
            Edit{" "}
          </span>
        )}
        {record.status === "unassigned" && (
          <span
            style={{ cursor: "pointer" }}
            onClick={() => toggleAssignWatchModal(record)}
          >
            {" "}
            Assign{" "}
          </span>
        )}

        {record.status === "assigned" && (
          <DeleteConfirmNew
            api="unassignHealthBand"
            type="EditInventory"
            loading="InventoryLoading"
            method="PUT"
            okText={"Yes"}
            selectedItem={{
              healthBandId: record?._id,
              careRecipientId: record?.assignedTo?._id,
            }}
            buttonName="Unassign"
            title="Are you sure you want to unassign this item?"
            content=""
            Icon={<span style={{ fontSize: "14px" }}>Unassign</span>}
          />
        )}

        {record.status !== "outOfOrder" && (
          <DeleteConfirmNew
            api="outOfOrderHealthBand"
            type="EditInventory"
            loading="InventoryLoading"
            method="PUT"
            okText={"Yes"}
            selectedItem={{ id: record._id }}
            buttonName="Out of Order"
            title="Are you sure you want to mark this item as out of order?"
            content=""
            Icon={<span style={{ fontSize: "14px" }}>Out of Order</span>}
          />
        )}

        {record.status !== "deleted" && (
          <DeleteConfirmNew
            api="deleteHealthBand"
            type="EditInventory"
            loading="InventoryLoading"
            method="PUT"
            okText={"Yes"}
            selectedItem={{ id: record._id }}
            buttonName="Delete"
            title="Are you sure you want to delete this item?"
            content=""
            Icon={<span style={{ fontSize: "14px" }}>Delete</span>}
          />
        )}

        {record.status === "outOfOrder" && (
          <DeleteConfirmNew
            api="repairHealthBand"
            type="EditInventory"
            loading="InventoryLoading"
            method="PUT"
            okText={"Yes"}
            selectedItem={{ id: record._id }}
            buttonName="Repair"
            title="Are you sure you want to mark this item as repaired?"
            content=""
            Icon={<span style={{ fontSize: "14px" }}>Repair</span>}
          />
        )}
      </div>
    );
  };

  return (
    <Layout>
      <div className="gx-d-block gx-flex-row gx-justify-content-between">
        <div className="gx-d-flex gx-flex-row">
          <div className="gx-mb-2 gx-mb-md-0">
            <Title title={<IntlMessages id="inventory.pageTitle" />} />
          </div>
        </div>

        <div className="gx-d-flex">
          <div className="gx-mr-3 gx-mb-3 gx-mb-md-0">
            <SelectFilter
              placeholder="Filter by status"
              isShowingAll={true}
              apiName="getAllHealthBands"
              searchKey="status"
              type="getInventory"
              options={[
                { status: "assigned", label: "Assigned" },
                { status: "unassigned", label: "Unassigned" },
                { status: "outOfOrder", label: "Out of Order" },
                { status: "deleted", label: "Deleted" },
              ]}
              ItemValue="status"
              label="label"
            />
          </div>
          <div
            className="gx-my-0 gx-mr-md-3 gx-mx-0"
            style={{ width: "200px" }}
          >
            <Input.Search
              showSearch
              placeholder="IMEI / Name / Model"
              filterOption={false}
              onChange={(e) =>
                dispatch(
                  DataGetActionAPI(
                    "getAllHealthBands",
                    "getInventory",
                    { name: e.target.value },
                    "InventoryLoading"
                  )
                )
              }
            />
          </div>
          <div>
            <Button
              type="primary"
              className="gx-pt-0 gx-ml-3"
              onClick={toggleAddItemModal}
            >
              <IntlMessages id="inventory.addItem" />
            </Button>
          </div>
        </div>
      </div>
      <InventoryTable
        loading={inventorySpinner}
        columns={columns}
        data={inventorySpinner ? [] : allInventory}
      />
      <AddItemModal />
      <EditItemModal />
      <AssignWatchModal />
    </Layout>
  );
};

export default Inventory;
